import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';

@Injectable()
export class SignupForm {

  constructor(private formBuilder: FormBuilder) {

  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      companyName: [ '', Validators.required ],
      email: [ '', Validators.compose([ Validators.required, CustomValidators.email ]) ],
      firstName: [ '', Validators.required ],
      lastName: [ '', Validators.required ],
      phone: [ '', Validators.required ],
      password: [ '', Validators.required ],
      terms: [ '', Validators.required ],
    });
  }
}
